import {useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import EditIndustry from "./EditIndustry";
import AddIndustry from "./AddIndustry";

const ListEndpoint = ApiEndpoints.industry.List;
const DeleteEndpoint = ApiEndpoints.industry.Delete;
const tableHeader = ["Date","Name", "status"];
const tbody = ["createdAt","name", "status"];

export default function Industry() {
  const [catId, setCatId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", ListEndpoint);
        const result = response.industries;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (industry_id) => {
      const payload = { industry_id };
      try {
        const response = await ApiRequest("POST", DeleteEndpoint, payload);
        toast.success(response.message);
        dataFetch();
      } catch (error) {
        console.log(error);
      }
    };

    const pagename = {
      name: 'Case Study Management',
      user: 'Admin',
      innerpage: 'Case Study Management / Industries'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}> Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          setModalShow={setModalEditShow}
          setId={setCatId}
          // onDelete={handleDelete}
        />
      </div>
      <AddIndustry show={modalShow} onHide={() => setModalShow(false)} />
      <EditIndustry show={modaleditShow} catId={catId} onHide={() => setModalEditShow(false)} />
    </>
  );
}
